import pkg from '../../package.json';

export const APP_VERSION = pkg.version || import.meta.env.VITE_APP_VERSION;
export const APP_NAME = "Supps & Peps Stack Tracker";
